<template>
  <div class="header-wrapper txt-center">
    <div class="h1">{{ mode === 'edit' ? 'Редактирование пользователя' : 'Добавление пользователя' }}</div>
  </div>
  <div class="base-form-wrapper">
    <Form ref="userForm"
          :validation-schema="dynamicSchema"
          v-slot="{ errors, meta, handleSubmit, setFieldValue, resetForm }"
          :initial-values="user"
          :validateOnMount="false"
          v-bind="validateMode"
          @invalid-submit="handleInvalidSubmit"
    >
      <form @submit.prevent="handleSubmit((values) => onSubmit(values, resetForm))" class="user-form base-form" autocomplete="off">
        <div v-if="mode === 'edit'" class="state-buttons-group flex">
          <!--Активен-->
          <label class="state-button state-active">
            <input type="radio"  v-model="formData.active" value="Y">
            <span class="state-button-box">
                  <span class="state-icon">
                    <svg class="svg-check">
                      <use href="/img/sprite.svg#svg-check"></use>
                    </svg>
                  </span>
                  <span class="font-15">Активен</span>
                </span>
          </label>
          <!--Заблокирован-->
          <label class="state-button state-locked" >
            <input type="radio" v-model="formData.active" value="N">
            <span class="state-button-box">
                  <span class="state-icon">
                    <svg class="svg-empty">
                      <use href="/img/sprite.svg#svg-empty"></use>
                    </svg>
                  </span>
                  <span class="font-15">Заблокирован</span>
                </span>
          </label>
        </div>
        <!--login-->
        <div class="form-row has-generate">
          <div class="form-item">
            <Field v-slot="{ field, errorMessage }" name="login">
              <label class="form-label">Логин</label>
               <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <div class="label-error" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>
                <input
                    class="input-slim"
                    type="text"
                    v-model="formData.login"
                    autocomplete="new-password"
                    @input="handleLoginInput($event, setFieldValue)"
                    v-bind="field"
                >
                <button class="generate-btn" type="button" @click="generateLogin(setFieldValue)">Сгенерировать</button>
              </div>
            </Field>
          </div>
        </div>

        <!--password-->
        <div class="form-row has-generate">
          <div class="form-item has-copy">
            <Field v-slot="{ field, errorMessage }" name="password">
              <label class="form-label">Пароль</label>
               <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <div class="label-error" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>
                <div class="form-passw relative-block" :class="{ 'form-passw-active': showPassword }">
                  <input
                      class="input-slim copy-input"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder=" "
                      v-model="formData.password"
                      v-bind="field"
                      autocomplete="new-password"
                  >
                  <span
                      class="show-passw btn-square"
                      @click="togglePasswordVisibility"
                  ></span>
                </div>
                <button class="generate-btn" type="button" @click="generatePassword(setFieldValue)">Сгенерировать</button>
                <button
                    class="btn-copy has-tooltip"
                    type="button"
                    rel="copy_button"
                    @click="copyPassword"
                >
                  <div class="btn-tooltip">{{ copyTooltip }}</div>
                </button>
              </div>
            </Field>
          </div>
        </div>

        <!--name-->
        <div class="form-item">
          <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur }" name="fio">
            <label class="form-label">ФИО</label>
            <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
              <input
                  class="input-slim"
                     type="text"
                  :value="value"
                  @input="(e) => { handleChange(e, !!errorMessage); formData.fio = e.target.value; }"
                  @blur="handleBlur"
              >
            </div>
          </Field>
        </div>
        <!--row-->
        <div class="form-row-30 width-50">
          <Field v-slot="{ errorMessage, handleChange }" name="role" :modelValue="formData.role">
            <div class="form-item">
              <label class="form-label">Должность</label>
            <SingleSelectDropdown
                v-model="formData.role"
                :options="roleOptions"
                placeholder="Выберите"
                name="role"
                @update:modelValue="handleChange"
            />
            </div>
            <div class="label-error" v-if="errorMessage">
              <span>{{ errorMessage }}</span>
            </div>
          </Field>
          <div class="form-item">
            <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur}" name="email_personal">
              <label class="form-label">E-mail персональный</label>
               <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <div class="label-error" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>
                <input class="input-slim" type="email" :value="value"
                       @input="(e) => { handleChange(e, !!errorMessage); formData.email_personal = e.target.value; }"
                       @blur="handleBlur">
              </div>
            </Field>
          </div>
        </div>

        <!--emails-->
        <div class="form-row-30 width-50" v-if="isVisible('email_group')">
          <div class="form-item" v-if="isVisible('email_group')">
            <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur }" name="email_group">
              <label class="form-label">E-mail общей группы</label>
               <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <div class="label-error" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>
                <input class="input-slim" type="email" :value="value"
                       @input="(e) => { handleChange(e, !!errorMessage); formData.email_group = e.target.value; }"
                       @blur="handleBlur">
              </div>
            </Field>
          </div>


          <div class="form-item" v-if="isVisible('phone')">
            <Field name="phone" v-slot="{ handleChange, errorMessage, handleBlur }" :modelValue="formData.phone">
              <label class="form-label">Телефон</label>
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
              <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <select class="input-slim phone-code-select" v-model="phoneCountryCode">
                  <option value="+7">+7</option>
                  <option value="+86">+86</option>
                </select>
                <input
                    class="input-slim phone-number-input"
                    type="tel"
                    v-model="formData.phone"
                    v-maska="{ mask: '(###) ###-##-##' }"
                    placeholder="(___) ___-__-__"
                    @input="(e) => { handleChange(formData.phone, !!errorMessage); }"
                    @blur="handleBlur"
                />
              </div>
            </Field>
          </div>
        </div>

        <div class="form-item" v-if="isVisible('linked_supplier')">
          <Field v-slot="{ errorMessage }" name="linked_supplier">
            <label class="form-label">Связанные поставщики</label>
            <div class="linked-suppliers">
              <div
                  v-for="(login, index) in formData.linked_supplier"
                  :key="index"
                  class="form-item-group flex"
                  :class="{'not-valid': errorMessage}"
              >
                <input
                    class="input-slim"
                    type="text"
                    :value="login"
                    placeholder="Введите логин поставщика"
                    @input="handleLinkedSupplierInput(index, $event, setFieldValue)"
                >
                <button
                    class="remove-item"
                    type="button"
                    @click="removeLinkedSupplier(index, setFieldValue)"
                >
                  <svg class="svg-cross">
                    <use href="/img/sprite.svg#svg-cross"></use>
                  </svg>
                  <span>Удалить</span>
                </button>
              </div>
              <button
                  class="add-item"
                  type="button"
                  @click="addLinkedSupplier(setFieldValue)"
              >
                <svg class="svg-plus">
                  <use href="/img/sprite.svg#svg-plus"></use>
                </svg>
                <span>Добавить еще</span>
              </button>
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
            </div>
          </Field>
        </div>

        <!--company name-->
        <div class="form-item" v-if="isVisible('company')">
          <Field v-slot="{ field, errorMessage }" name="company">
            <label class="form-label">Наименование организации поставщика</label>
             <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
              <input class="input-slim" type="text" v-model="formData.company" v-bind="field">
            </div>
          </Field>
        </div>

        <!--ИНН-->
        <div class="form-row-30">
          <div class="form-item grow" v-if="isVisible('code')">
            <Field v-slot="{ field, errorMessage }" name="code">
              <label class="form-label">{{formData.role === 'manager'?'Код физлица из Управления Торговлей':'Код организации из Управления Торговлей'}}</label>
               <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <div class="label-error" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>
                <input class="input-slim" type="text" v-model="formData.code" v-bind="field">
              </div>
            </Field>
          </div>
          <div class="form-item width-175" v-if="isVisible('inn')">
            <Field v-slot="{ field, errorMessage }" name="inn">
              <label class="form-label">ИНН</label>
               <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
                <div class="label-error" v-if="errorMessage">
                  <span>{{ errorMessage }}</span>
                </div>
                <input class="input-slim" type="number" v-model="formData.inn" v-bind="field">
              </div>
            </Field>
          </div>
        </div>

        <!--row-->
        <div class="form-item" v-if="isVisible('address_fact')">
          <Field v-slot="{ field, errorMessage }" name="address_fact">
            <label class="form-label">Фактический адрес</label>
             <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
              <input class="input-slim" type="text" v-model="formData.address_fact" v-bind="field">
            </div>
          </Field>
        </div>

        <!--row-->
        <div class="form-item" v-if="isVisible('address_legal')">
          <Field v-slot="{ field, errorMessage }" name="address_legal">
            <label class="form-label">Юридический адрес</label>
             <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
              <input class="input-slim" type="text" v-model="formData.address_legal" v-bind="field">
            </div>
          </Field>
        </div>

        <!--Склады-->
        <div class="form-item form-item-storage" v-if="isVisible('storages')">
          <Field name="storages" v-slot="{ errorMessage, handleChange }" :modelValue="formData.storages">
          <label class="form-label">Склад отгрузки</label>
          <div class="flex-column">
            <div
                v-for="(storage, index) in formData.storages"
                :key="storage.id"
                class="form-row-20"
            >
              <input
                  class="input-slim"
                  type="text"
                  v-model="storage.value"
                  placeholder="Введите адрес склада"
                  @input="handleChange(formData.storages)"
              >
              <button
                  v-if="index === formData.storages.length - 1"
                  class="add-item"
                  type="button"
                  @click="addStorage"
              >
                <svg class="svg-plus">
                  <use href="/img/sprite.svg#svg-plus"></use>
                </svg>
                <span>Добавить еще</span>
              </button>
              <button
                  v-else
                  class="remove-item"
                  type="button"
                  :disabled="formData.storages.length === 1"
                  @click="removeStorage(index); handleChange(formData.storages)"
              >
                <svg class="svg-cross">
                  <use href="/img/sprite.svg#svg-cross"></use>
                </svg>
                <span>Удалить</span>
              </button>
            </div>
          </div>
            <div class="label-error" v-if="errorMessage">
              <span>{{ errorMessage }}</span>
            </div>
          </Field>
        </div>

        <!--company BOSS-->
        <div class="form-item" v-if="isVisible('fio_boss')">
          <Field v-slot="{ field, errorMessage }" name="fio_boss">
            <label class="form-label">ФИО руководителя</label>
             <div class="form-item-group flex" :class="{'not-valid': errorMessage}">
              <div class="label-error" v-if="errorMessage">
                <span>{{ errorMessage }}</span>
              </div>
              <input class="input-slim" type="text" v-model="formData.fio_boss" v-bind="field">
            </div>
          </Field>
        </div>

        <Field v-if="isVisible('suppliers')" name="suppliers" v-slot="{ errorMessage, handleChange }" :modelValue="formData.suppliers">
        <!--поставщики-->
        <MultiSelectDropdown
            v-model="formData.suppliers"
            :options="supplierOptions"
            label="Привязанные поставщики"
            placeholder="Выберите"
            name="suppliers"
            :errorMessage="errorMessage"
            @update:modelValue="handleChange"
        />
        </Field>
        <!--comment-->
        <div class="form-item">
          <Field v-slot="{ field, errorMessage }" name="comment">
            <label class="form-label">Комментарий</label>
            <div class="label-error" v-if="errorMessage">
              <span>{{ errorMessage }}</span>
            </div>
            <textarea class="textarea" v-model="formData.comment" v-bind="field"></textarea>
          </Field>
        </div>

        <div class="error-message" v-if="serverError">
          <span v-html="serverError"></span>
        </div>

        <div class="success-message" v-if="successMessage">
          <span v-html="successMessage"></span>
        </div>

        <!--form bottom buttons-->
        <div class="form-buttons flex mt-10">
          <button class="btn grow" :class="{loader: isSubmitting}" :disabled="!meta.valid">{{ mode === 'edit' ? 'Сохранить изменения' : 'Создать пользователя' }}</button>
          <router-link to="/users/" class="btn-outline">Отмена</router-link>
        </div>
      </form>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SingleSelectDropdown from '@/components/form/SingleSelectDropdown.vue';
import MultiSelectDropdown from '@/components/form/MultiSelectDropdown.vue';
import scrollToError from "@/mixin/scrollToError.vue";
import { Form, Field, useForm } from 'vee-validate';
import * as yup from 'yup';
import axios from 'axios';
import { vMaska } from 'maska/vue';

export default {
  components: {
    SingleSelectDropdown,
    MultiSelectDropdown,
    Form, Field
  },
  directives: { maska: vMaska },
  mixins: [scrollToError],
  props: {
    mode: {
      type: String,
      default: 'add' // 'add' | 'edit'
    },
    user: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    formData: {
      login: '',
      password: '',
      fio: '',
      role: 'manager',
      email_personal: '',
      email_group: '',
      linked_supplier: [],
      phone: '',
      company: '',
      code: '',
      inn: '',
      address_fact: '',
      address_legal: '',
      fio_boss: '',
      suppliers: [],
      storages: [
        { id: 1, value: '' }
      ],
      comment: '',
    },
    //initialFormValues: {},
    phoneCountryCode: '+7',
    nextStorageId: 2,
    showPassword: false,
    copyTooltip: 'Копировать',
    isSubmitting: null,
    serverError: null,
    successMessage: null,
  }),
  setup() {
    const validateMode = {
      validateOnBlur: true,
      validateOnChange: false,
      validateOnInput: false,
      validateOnModelUpdate: false
    };

    return {
      validateMode
    };
  },
  created() {
    if (this.mode === 'edit') {
      this.formData = { ...this.user };
      this.formData.login = this.normalizeLogin(this.formData.login);
      this.formData.linked_supplier = this.normalizeLinkedSuppliers(this.formData.linked_supplier);
      this.splitPhoneCountryCode();
      //this.initialFormValues = { ...this.user };
    }
  },
  computed: {
    ...mapGetters('app', [
      'roleOptions',
        'supplierOptions'
    ]),
    role_fields_config() {
      let result = {};
      this.roleOptions.forEach(field => {
        result[field.value] = field.settings;
      });
      return result;
    },
    currentRoleConfig() {
      return this.role_fields_config[this.formData.role] ?? { visible: [], required: [] };
    },
    isVisible() {
      return (field) => this.currentRoleConfig.visible.includes(field);
    },
    isRequired() {
      return (field) => this.currentRoleConfig.required.includes(field);
    },
    dynamicSchema() {
      const req = this.isRequired;

      const str = (field, msg, extra = (s) => s) => {
        const schema = extra(yup.string());
        return req(field) ? schema.required(msg) : schema.optional();
      };
      const phonePattern = /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/;

      return yup.object().shape({
        login: str('login', 'Логин обязателен', s => s.min(2, 'Минимум 2 символа')),
        password: this.mode === 'edit'
            ? yup.string().optional().min(6, 'Минимум 6 символов')
            : str('password', 'Пароль обязателен', s => s.min(6, 'Минимум 6 символов')),
        fio: str('fio', 'ФИО обязательно', s => s.min(2, 'Минимум 2 символа')),
        role: yup.string().required('Должность обязательна'),
        email_personal: str('email_personal', 'Email обязателен', s => s.email('Некорректный email')),
        email_group: str('email_group', 'Email группы обязателен', s => s.email('Некорректный email')),
        linked_supplier: req('linked_supplier')
            ? yup.array().of(yup.string()).min(1, 'Укажите хотя бы одного связанного поставщика')
            : yup.array().of(yup.string()).optional(),
        phone: str('phone', 'Телефон обязателен', s => s.matches(phonePattern, {
          excludeEmptyString: true,
          message: 'Некорректный телефон',
        })),
        company: str('company', 'Наименование организации обязательно'),
        code: str('code', 'Код организации обязателен'),
        //inn: str('inn', 'ИНН обязателен'),
        address_fact: str('address_fact', 'Фактический адрес обязателен'),
        address_legal: str('address_legal', 'Юридический адрес обязателен'),
        fio_boss: str('fio_boss', 'ФИО руководителя обязательно'),
        comment: str('comment', 'Комментарий обязателен'),
        storages: req('storages')
            ? yup.array().test('filled', 'Укажите хотя бы один склад',
                v => Array.isArray(v) && v.some(s => s.value?.trim()))
            : yup.array().optional(),
        suppliers: req('suppliers')
            ? yup.array().min(1, 'Выберите хотя бы одного поставщика')
            : yup.array().optional(),
      });
    },
  },
  watch: {
    'formData.role'(newRole, oldRole) {
      const oldConfig = this.role_fields_config[oldRole] ?? { visible: [] };
      const newConfig = this.role_fields_config[newRole] ?? { visible: [] };

      oldConfig.visible.forEach(field => {
        if (!newConfig.visible.includes(field) && field !== 'role') {
          this.formData[field] = Array.isArray(this.formData[field]) ? [] : '';
        }
      });

      this.$nextTick(() => {
        this.$refs.userForm?.setErrors({});
      });
    }
  },
  methods: {
    normalizeLogin(value) {
      return String(value ?? '').replace(/\s/gu, '');
    },

    handleLoginInput(event, setFieldValue) {
      const login = this.normalizeLogin(event.target.value);

      event.target.value = login;
      this.formData.login = login;
      setFieldValue('login', login, true);
    },

    normalizeLinkedSuppliers(values) {
      const source = Array.isArray(values) ? values : [values];
      const seen = new Set();

      return source.reduce((result, value) => {
        const login = this.normalizeLogin(value);
        const key = login.toLocaleLowerCase();
        if (login && !seen.has(key)) {
          seen.add(key);
          result.push(login);
        }
        return result;
      }, []);
    },

    handleLinkedSupplierInput(index, event, setFieldValue) {
      const login = this.normalizeLogin(event.target.value);

      event.target.value = login;
      this.formData.linked_supplier[index] = login;
      setFieldValue('linked_supplier', [...this.formData.linked_supplier], true);
    },

    addLinkedSupplier(setFieldValue) {
      this.formData.linked_supplier.push('');
      setFieldValue('linked_supplier', [...this.formData.linked_supplier], false);
    },

    removeLinkedSupplier(index, setFieldValue) {
      this.formData.linked_supplier.splice(index, 1);
      setFieldValue('linked_supplier', [...this.formData.linked_supplier], true);
    },

    generateLogin(setFieldValue) {
      const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
      const length = 8;
      let login = 'user_';
      for (let i = 0; i < length; i++) {
        login += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      setFieldValue('login', login);
      this.formData.login = login;
    },

    generatePassword(setFieldValue) {
      const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const lowercase = 'abcdefghijklmnopqrstuvwxyz';
      const numbers = '0123456789';
      const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';
      const allChars = uppercase + lowercase + numbers + symbols;

      const length = 12;
      let password = '';

      password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
      password += lowercase.charAt(Math.floor(Math.random() * lowercase.length));
      password += numbers.charAt(Math.floor(Math.random() * numbers.length));
      password += symbols.charAt(Math.floor(Math.random() * symbols.length));

      for (let i = password.length; i < length; i++) {
        password += allChars.charAt(Math.floor(Math.random() * allChars.length));
      }

      password = password.split('').sort(() => Math.random() - 0.5).join('');
      setFieldValue('password', password);
      this.formData.password = password;
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    async copyPassword() {
      if (!this.formData.password) {
        return;
      }

      try {
        await navigator.clipboard.writeText(this.formData.password);
        this.copyTooltip = 'Скопировано!';
        setTimeout(() => {
          this.copyTooltip = 'Копировать';
        }, 2000);
      } catch (err) {
        console.error('Ошибка копирования:', err);
        const input = document.createElement('input');
        input.value = this.formData.password;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.copyTooltip = 'Скопировано!';
        setTimeout(() => {
          this.copyTooltip = 'Копировать';
        }, 2000);
      }
    },

    addStorage() {
      this.formData.storages.push({
        id: this.nextStorageId++,
        value: ''
      });
    },

    removeStorage(index) {
      if (this.formData.storages.length > 1) {
        this.formData.storages.splice(index, 1);
      }
    },

    handleInvalidSubmit() {
      this.scrollToFirstError();
    },

    splitPhoneCountryCode() {
      if (!this.formData.phone) {
        return;
      }

      const phone = this.formData.phone.trim();

      if (phone.startsWith('+86')) {
        this.phoneCountryCode = '+86';
        this.formData.phone = phone.replace(/^\+86\s*/, '');
      } else if (phone.startsWith('+7')) {
        this.phoneCountryCode = '+7';
        this.formData.phone = phone.replace(/^\+7\s*/, '');
      }

      this.formData.phone = this.normalizePhoneLocalPart(this.formData.phone);
    },

    normalizePhoneLocalPart(phone) {
      const localPhonePattern = /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/;

      if (!phone || localPhonePattern.test(phone)) {
        return phone;
      }

      const digits = phone.replace(/\D/g, '');

      if (digits.length !== 10) {
        return phone;
      }

      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 8)}-${digits.slice(8, 10)}`;
    },

    buildPhoneWithCountryCode() {
      return this.formData.phone ? `${this.phoneCountryCode} ${this.formData.phone}` : '';
    },

    async onSubmit(values, resetForm) {
      this.isSubmitting = true;
      this.serverError = null;
      this.successMessage = null;
      const normalizedLogin = this.normalizeLogin(this.formData.login);
      const normalizedLinkedSuppliers = this.normalizeLinkedSuppliers(this.formData.linked_supplier);

      this.formData.login = normalizedLogin;
      this.formData.linked_supplier = normalizedLinkedSuppliers;

      const formDataToSubmit = {
        ...this.formData,
        login: normalizedLogin,
        linked_supplier: normalizedLinkedSuppliers,
        phone: this.buildPhoneWithCountryCode(),
      };

      try {

        let url = '';
        if (this.mode === 'edit') {
          url = `/api/user/${this.user.id}/`;
        } else {
          url = `/api/user/`;
        }

        // отправка данных на сервер
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          if (this.mode === 'edit') {
            this.successMessage = 'Пользователь успешно сохранен';
            setTimeout(() => {
              this.successMessage = null;
            }, 5000);
          }
          else {
            this.successMessage = 'Пользователь успешно добавлен';
            setTimeout(() => {
              this.successMessage = null;
            }, 5000);
            Object.keys(this.formData).forEach(field => {
              this.formData[field] = Array.isArray(this.formData[field]) ? [] : '';
            });
            resetForm();
            this.formData.role = 'manager';
            this.phoneCountryCode = '+7';
          }
        }

      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
  }
}
</script>

<style scoped>
.phone-code-select {
  flex: 0 0 5.25rem;
}

.phone-number-input {
  flex: 1 1 auto;
}

.linked-suppliers {
  display: grid;
  gap: 0.75rem;
}
</style>
